import { i18n } from '@lingui/core';
import { MessageDTO } from '../Types/MessageT';
import { ajaxActions } from './AjaxActions';
import { ToastS } from './ToastS';

const BASE_URL = process.env.REACT_APP_PLACEHOLDER_SERVICE_URL;

const replaceMessage = async (email: MessageDTO): Promise<MessageDTO | null> => {
  const { from, to, cc, bcc, ...rest } = email;
  const res = await ajaxActions.post(`${BASE_URL}/replace/email`, { ...rest });
  if (res.ok) {
    const resJSON = await res.json();
    const { subject, message } = resJSON;
    return { ...email, subject, message };
  }
  if (res.status === 412) {
    ToastS.cleanAll();
    ToastS.error('find.unresolved.placeholders', 'E-Mail enthält nicht ersetzbare Platzhalter');
    const unresolvedPlaceholders = await res.json();
    unresolvedPlaceholders.forEach((placeholder: string) => {
      const translation = i18n._(placeholder, { 0: 1 });
      ToastS.error(`placeholder.unsatisfied-${translation}`, i18n._(`${translation} nicht gesetzt`));
    });
  }
  return null;
};

const checkPlaceholders = async (email: Partial<MessageDTO>): Promise<boolean> => {
  const res = await ajaxActions.post(`${BASE_URL}/replace/email`, email);
  if (res.ok) {
    return true;
  }
  if (res.status === 412) {
    ToastS.cleanAll();
    ToastS.error('find.unresolved.placeholders', 'E-Mail enthält nicht ersetzbare Platzhalter');
    const unresolvedPlaceholders = await res.json();
    unresolvedPlaceholders.forEach((placeholder: string) => {
      const translation = i18n._(placeholder, { 0: 1 });
      ToastS.error(`placeholder.unsatisfied-${translation}`, i18n._(`${translation} nicht gesetzt`));
    });
  }
  return false;
};

const getUnresolvedPlaceholders = async (entityId: string | number, entityType: string): Promise<boolean> => {
  const res = await ajaxActions.get(`${BASE_URL}/unresolvedPlaceholders/${entityType}/${entityId}`);
  if (res.ok) {
    const unresolvedPlaceholders: string[] = await res.json();
    if (unresolvedPlaceholders.length > 0) {
      ToastS.warn('placeholder.unsatisfied', i18n._('placeholder.unsatisfied'));
      unresolvedPlaceholders.forEach((placeholder) => {
        const translation = i18n._(placeholder, { 0: 1 });
        ToastS.warn(`unresolvable.placeholder-${translation}`, i18n._(`${translation} nicht gesetzt`));
      });
      return false;
    }
    return true;
  }
  return false;
};

const hasUnresolvedPlaceholdersPost = async (
  entityId: string | number,
  entityType: string,
  body?: unknown,
  notification = true,
): Promise<boolean> => {
  const res = await ajaxActions.post(`${BASE_URL}/unresolvedPlaceholders/${entityType}/${entityId}`, body);
  if (res.ok) {
    const unresolvedPlaceholders: string[] = await res.json();
    if (unresolvedPlaceholders.length > 0) {
      if (notification) {
        ToastS.warn('placeholder.unsatisfied', i18n._('placeholder.unsatisfied'));
        unresolvedPlaceholders.forEach((placeholder) => {
          const translation = i18n._(placeholder, { 0: 1 });
          ToastS.warn(`unresolvable.placeholder-${translation}`, i18n._(`${translation} nicht gesetzt`));
        });
      }
      return true;
    }
    return false;
  }
  return true;
};

// eslint-disable-next-line import/prefer-default-export
export const PlaceholderS = {
  replaceMessage,
  checkPlaceholders,
  getUnresolvedPlaceholders,
  hasUnresolvedPlaceholdersPost,
};
